import React from 'react';
import ClientInvoiceAssignmentSearchParams from './ClientInvoiceAssignmentSearchParams';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ClientInvoiceAssignmentItem from '../../../../Domain/ClientInvoiceAssignmentItem';
import VZeusAssignmentListInvoicedService from '../../../../Services/VZeusAssignmentListInvoicedService';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import EditMultipleAssignmentWindowDescription from './EditMultipleAssignmentWindowDescription';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ClientLineItemService from '../../../../Services/ClientLineItemService';
import ClientInvoiceService from '../../../../Services/ClientInvoiceService';
import ApplyPaymentItem from '../../../../Domain/ApplyPaymentItem';
import ClientPaymentService from '../../../../Services/ClientPaymentService';
import ApplyPaymentPanel from '../../../Finance/ClientPayment/ApplyPaymentPanel';

export default class AssignmentsSubTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new ClientInvoiceAssignmentSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      allItemsInTheSearchSetAreSelected: false,
      numberOfElementsInTheTable: 0,
      statusId: null,
      clientId: null,
    };
    this.state.searchItem.ClientInvoiceId = this.props.clientInvoiceId;
    ClientInvoiceAssignmentSearchParams.getClientId = () => this.state.clientId;

    this.startSearch = this.startSearch.bind(this);
    this.serviceFunction = this.serviceFunction.bind(this);
    this.refresh = this.refresh.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.removePaymentFunction = this.removePaymentFunction.bind(this);
  }

  refresh(reload) {
    if (reload) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
      return;
    }
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  isButtonDisabled() {
    return !this.state.statusId || this.state.statusId === 2 || this.state.statusId === 3;
  }

  componentDidMount() {
    ClientInvoiceService.GetByInvoiceId(this.props.clientInvoiceId)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          this.setState({ statusId: result.ciStatusCode, clientId: result.ciCcid });
        }
      })
      .catch((error) => ErrorMessage.SetErrorMessage('AST57', error));
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => {
                VZeusAssignmentListInvoicedService.ExportToExcel(this.state.searchItem)
                  .then((result) => {
                    if (result && result.error) {
                      ErrorMessage.SetErrorMessage(result.error);
                    } else {
                      ErrorMessage.SetNotification('Exported to Excel.');
                    }
                  })
                  .catch(() => ErrorMessage.SetErrorMessage('AST95'));
              },
              label: 'Export to Excel',
              tooltip: 'Export to Excel',
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () =>
                ErrorMessage.SetApprove(
                  `Remove ${this.getNumberOfSelectedElements()} Assignment(s) from their invoice?`,
                  this.removeFunction
                ),
              label: 'Remove Line Items',
              tooltip: 'Remove Line Items',
              roleKey: 'clientinvoice_removelineitem',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.showPanel(ShownPanelsEnum.MultiEdit),
              label: 'Update Multiple Records',
              tooltip: 'Update Multiple Records',
              roleKey: 'clientinvoice_updatemultiplerecords',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => {
                this.setState({
                  shownPanel: ShownPanelsEnum.ApplyPayment,
                  selectedItem: this.getApplyPaymentItem(),
                });
              },
              label: 'Apply Payment(s)',
              tooltip: 'Apply Payment(s)',
              roleKey: 'clientpayment_apply',
              disabled: this.getNumberOfSelectedElements() === 0 || this.state.statusId !== 2,
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.removePaymentFunction),
              label: 'Remove Payment(s)',
              tooltip: 'Remove Payment(s)',
              roleKey: 'clientpayment_remove',
              disabled:
                this.getNumberOfSelectedElements() === 0 || (this.state.statusId !== 2 && this.state.statusId !== 3),
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  removePaymentFunction() {
    const selectedItem = new ApplyPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.getNumberOfSelectedElements();
    selectedItem.ClientPaymentId = this.props.clientPaymentId;
    selectedItem.ClientInvoiceId = this.props.clientInvoiceId;
    selectedItem.LineItemIds = this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => `Assignment_${x.AsId}`);
    selectedItem.AssignmentSearchParams = this.state.searchItem;

    ClientPaymentService.RemovePayment(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment removed from Assignment(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AST159', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Remove the payment of all currently selected (${this.state.numberOfElementsInTheTable}) Assignments?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.AsId);
    return `Remove the payment of the selected ${idList.length} Assignment(s)?`;
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.MultiEdit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.getEditItem()}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditMultipleAssignmentWindowDescription}
            errorCode={'AST102'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.ApplyPayment,
          <ApplyPaymentPanel
            baseItem={this.state.selectedItem}
            refresh={this.refresh}
          />
        )}
      </div>
    );
  }

  getApplyPaymentItem() {
    const item = new ApplyPaymentItem();
    item.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    item.NumberOfItemsSelected = this.getNumberOfSelectedElements();
    item.LineItemIds = this.state.itemList.filter((i) => i.Selected === true).map((x) => `Assignment_${x.AsId}`);
    item.ClientInvoiceId = this.props.clientInvoiceId;
    item.AssignmentSearchParams = this.state.searchItem;
    return item;
  }

  removeFunction() {
    ClientLineItemService.RemoveLineItemsFromClientInvoice(this.getEditItem())
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          ErrorMessage.SetLoading(false);
          this.refresh(false);
          return;
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Line Item(s) Removed.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AST181', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  // When the whole search set is selected the browser only holds the current page, so the
  // currencies resolved here are a best effort for labelling. The backend re-resolves them
  // across every affected assignment and refuses the update if they are not all the same.
  getRowsBehindTheSelection() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.itemList
      : this.state.itemList.filter((i) => i.Selected);
  }

  getEditItem() {
    const rows = this.getRowsBehindTheSelection();
    const distinct = (value, index, array) => array.indexOf(value) === index;
    // Assignments with no evaluator payment yet are never touched by the evaluator update,
    // so they must not widen the currency set.
    const evaluatorCurrencies = rows
      .map((f) => f.IeRcycode)
      .filter((code) => code)
      .filter(distinct);

    return {
      AssignmentIds: this.state.itemList.filter((i) => i.Selected).map((f) => f.AsId),
      Currencies: rows.map((f) => f.PricingCurrencyCode).filter(distinct),
      EvaluatorCurrencies: evaluatorCurrencies,
      EvCurrencyCode: evaluatorCurrencies.length === 1 ? evaluatorCurrencies[0] : '',
      LineItemIds: [],
      AllItemsInTheSearchSetAreSelected: this.state.allItemsInTheSearchSetAreSelected,
      NumberOfItemsSelected: this.getNumberOfSelectedElements(),
      AssignmentSearchItem: this.state.searchItem,
    };
  }

  getNumberOfSelectedElements() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
  }

  startSearch(searchItem) {
    // "Clear All Filters" hands back a fresh search item without the invoice id. The list re-adds it
    // for its own fetch, but the bulk actions send this item as it is and the server refuses it.
    searchItem.ClientInvoiceId = this.props.clientInvoiceId;
    this.setState({ searchItem });
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({
      itemList,
      numberOfElementsInTheTable,
    });
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const tempSearchItem = { ...searchItem };
    tempSearchItem.ClientInvoiceId = this.props.clientInvoiceId;
    return VZeusAssignmentListInvoicedService.GetListBySearching(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      tempSearchItem,
      clearCache
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ClientInvoiceAssignmentItem}
          serviceFunction={this.serviceFunction}
          convertDBItemsFunction={VZeusAssignmentListInvoicedService.ConvertDBItems}
          searchParamsType={ClientInvoiceAssignmentSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='AsCfname'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in assignment apollo ID...'
          selectable={this.state.shownPanel === ShownPanelsEnum.None}
          itemList={this.state.itemList}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          changeOfItemListFunction={this.changeOfItemListFunction}
          errorCode='AST191'
        />
      </div>
    );
  }
}
